$(function() {

    var offCanvas = $('.uk-offcanvas-content');

    $('.uk-navbar-dropdown').on('show', function() {
        offCanvas.addClass('tm-overlay');
    });

    $('.uk-navbar-dropdown').on('hide', function() {
        offCanvas.removeClass('tm-overlay');
    });

})



// WEBPACK FOOTER //
// ./assets/js/layout.js